import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconQuestionMarkCircle } from '@gto/ui/assets'
import { Button } from '@gto/ui/button'
import { Tooltip } from '@gto/ui/tooltip'

import { type RedemptionOption } from '@/api/gen'
import { useEdgeBalance } from '@/hooks/use-edge-balance'

import { RedeemSubscriptionModal } from './redeem-subscription-modal'

export type RedeemButtonProps = {
  isActive?: boolean
  plan: RedemptionOption
}

export const RedeemButton = ({ isActive = false, plan }: RedeemButtonProps) => {
  const { formatMessage } = useIntl()
  const [showModal, setShowModal] = useState(false)
  const { isDiscounted, balance, loading } = useEdgeBalance()

  const finalPrice = isDiscounted && !loading ? plan.cost * 0.5 : plan.cost
  const isEnoughBalance = balance >= finalPrice

  const onToggleModal = () => {
    setShowModal((prev) => !prev)
  }

  return (
    <>
      <Tooltip
        content={formatMessage({ id: 'edge.plansSection.notEnoughBalance' })}
        disabled={isEnoughBalance}
      >
        <span>
          <Button
            fullWidth
            color="primary"
            disabled={!isActive || !isEnoughBalance}
            size="large"
            startIcon={!isEnoughBalance && <IconQuestionMarkCircle width={16} />}
            variant="contained"
            onClick={onToggleModal}
          >
            <FormattedMessage id="common.controls.redeemNow" />
          </Button>
        </span>
      </Tooltip>
      <RedeemSubscriptionModal
        open={showModal}
        plan={plan}
        onClose={onToggleModal}
      />
    </>
  )
}
